/* unplugin-vue-components disabled */import { render } from "./ThemeBar.vue?vue&type=template&id=64f6e9f2&scoped=true"
import script from "./ThemeBar.vue?vue&type=script&lang=js"
export * from "./ThemeBar.vue?vue&type=script&lang=js"

import "./ThemeBar.vue?vue&type=style&index=0&id=64f6e9f2&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\internation-fta-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f6e9f2"]])

export default __exports__